export enum FORM_CHECKBOX_TYPES {
  SELECT_PETS = 'SELECT_PETS'
}

export const FORM_CHECKBOX_COMPONENT_TYPES = {
  SELECT_PETS: {
    title: 'Who is this for?',
    requiredMessage: 'Please select a pet'
  }
} as const;
